<template>
  <v-col cols="12" xl="6">
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <div class="stats-title">
            <h3>{{ $t(title) }}</h3>
            <v-tooltip
              v-if="tooltip"
              bottom
              :max-width="400"
              nudge-right="100%"
              transition="fade-transition"
              content-class="tooltip-content">
              <template v-slot:activator="{on, attrs}">
                <v-icon class="fa-light fa-circle-info click" color="tertiary" dense v-on="on" v-bind="attrs" />
              </template>
              <span v-html="$t(tooltip)"></span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <CardTrend
            :loading="loading"
            :title1="$t('honda.dashboard.stats.leads.received')"
            :value1="data.leads"
            :percent="data.leadsYoy"
            :year="data.year" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardGauge
            :loading="loading"
            :title="$t('honda.dashboard.stats.leads.attended')"
            :current="data.attended48h"
            :percent="data.attended48hPerc"
            :target="data.attended48hTarget"
            :status="data.attended48hStatus" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardGauge
            :loading="loading"
            :title="$t('honda.dashboard.stats.leads.with-offer')"
            :current="data.withOffer"
            :percent="data.withOfferPerc"
            :target="data.withOfferTarget"
            :status="data.withOfferStatus" />
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import CardTrend from '@/components/metrics/CardTrend.vue'

import CardGauge from './CardGauge.vue'

export default defineComponent({
  name: 'StatsLeads',
  components: {
    CardTrend,
    CardGauge,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
})
</script>
